import { render } from "./CrudView.vue?vue&type=template&id=39fc1e3e&scoped=true"
import script from "./CrudView.vue?vue&type=script&lang=js"
export * from "./CrudView.vue?vue&type=script&lang=js"

import "./CrudView.vue?vue&type=style&index=0&id=39fc1e3e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39fc1e3e"]])

export default __exports__